import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { purple, transition } from './glowUtil'
import { DOT_PREFIX } from './constant'

const focusGlow = `0 0 0 2px ${purple[500]}12, 0 0 4px ${purple[500]}08 !important`

export default genComponentStyleHook(['DatePicker', 'heroTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      transition,
      borderRadius: 12,

      '&:hover': {
        borderColor: `${purple[400]} !important`,
      },

      [`&${componentCls}-focused`]: {
        borderColor: `${purple[500]} !important`,
        boxShadow: focusGlow,
      },
    },
  }
})
